import React from "react";
import VideoHomePageListPresenter from "./VideoHomePageList.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./VideoHomePageList.type";
import {
  VideoOutputModel,
  RootState,
  TCb,
  LanguageOutputModel,
  AppNotifications,
  VideoFlag,
  VideoStatus,
  VideoInputModel
} from "../../../../../models";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import _ from "lodash";

import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../../constants";

import { VideoService } from "../../../../../services";
import { VideoUtil, loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

class VideoHomePageListContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const videoCode = this.props.match.params.videoCode;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedAllVideo: INITIAL_FETCHING_PAGINATION_DATA,
      fetchedVideo: [],
      visibleVideoCode: videoCode,
      visibleVideoForm: Boolean(videoCode),

      activeLanguageId: "",
    };
  }

  openVideoFormModal = (videoCode?: string) => {
    this.setState({ visibleVideoCode: videoCode, visibleVideoForm: true }, () => {
      if (videoCode) {
        this.props.history.push(VideoUtil.buildHomepageDetailPath(videoCode));
      }
    });
  };

  closeVideoFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.BASE);
    this.setState({ visibleVideoCode: undefined, visibleVideoForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onDeleteVideo = (videoCode) => {
    VideoService.deleteVideo(videoCode)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete video success",
          });
          this.onApplyFilter(false);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete video failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete video failed" });
      });
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  handleChangeStatus = async (videoCode: string, newStatus: string) => {
    newStatus = newStatus === VideoStatus.PUBLISH ? VideoStatus.UNPUBLISH : VideoStatus.PUBLISH

    await VideoService.getVideo(videoCode)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          const data: VideoOutputModel[] = res.data.data;

          this.setState({
            fetchedVideo: data,
          });
        }
        else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
          this.props.history.goBack();
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Load data failed",
        });
      });

    const data: VideoInputModel[] = [];
    this.state.fetchedVideo.forEach((item) => {
      let dataObj: any = {
        id: item.id,
        languageId: item.languageId,
        description: item.description,
        title: item.title,
        video: item.video,
        linkVideo: item.linkVideo,
        status: newStatus,
        flag: item.flag
      }
      // dataObj = _.pickBy(dataObj, (v) => !_.isUndefined(v));
      data.push(dataObj);
    })

    VideoService.updateVideo(videoCode, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Update success" });
          this.onApplyFilter(false);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update failed" });
        }
      })
      .catch((err) => {
        console.log(err)
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update failed" });
      });
  }

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedAllVideo.loading && loadMore) return;
    this.props.all_language_list.data.forEach((e: LanguageOutputModel) => {
      if (e.isPrimary) {
        this.setState({
          activeLanguageId: e.id,
        })
      }
    })

    this.setState(
      (prevState) => {
        return {
          fetchedAllVideo: {
            ...prevState.fetchedAllVideo,
            data: loadMore ? prevState.fetchedAllVideo.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof VideoService.getFilterVideo>[0] = {
          page: loadMore ? this.state.fetchedAllVideo.page + 1 : 1,
          limit: this.state.fetchedAllVideo.limit,
          languageId: this.state.activeLanguageId,
          searchValue: this.state.filter.searchValue,
          flag: VideoFlag.HOMEPAGE
        };

        VideoService.getFilterVideo(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let videos: VideoOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    videos.unshift(...prevState.fetchedAllVideo.data);
                  }

                  return {
                    fetchedAllVideo: {
                      ...res.data,
                      data: videos,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.setState({
                fetchedAllVideo: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedAllVideo: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  componentDidMount() {
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false);
        }
      })
    }
    else {
      this.onApplyFilter(false);
    }
  }

  render() {
    return (
      <VideoHomePageListPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        handleChangeStatus={this.handleChangeStatus}
        openVideoFormModal={this.openVideoFormModal}
        closeVideoFormModal={this.closeVideoFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
        onDeleteVideo={this.onDeleteVideo}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(VideoHomePageListContainer)
);
